<template lang="pug">
  bloco#album.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper {{ album.titulo }}
      p {{ album.data }}
      p {{ album.descricao }}
    //- CONTENT
    .conteudo(slot="content" v-if="!naoTemFotos")
      galeria-album(v-if="album.imagens.length", :images="album.imagens")
    //- FOOTER
    footer(slot="footer" v-if="album.imagens.length")
      br
      back-and-share
    //- FEEDBACK
    template(slot="feedback" v-if='naoTemFotos')
      br
      mensagem.-warn
        p Nenhum álbum foi encontrado no momento
</template>

<style lang="scss">
  #album {
    > .conteudo {
      > .lista {
        margin: 30px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > .item {
          display: block;
          max-width: 150px;
          margin-bottom: 30px;
          &:hover {
            color: inherit;
            text-decoration: none;
          }
          > a {
            > img {
              height: 130px;
              width: 150px;
              object-fit: cover;
              border-radius: 7px;
              margin-bottom: 7px;
            }
          }
        }
      }
    }

    @include media(">=phone","<tablet") {
      > .conteudo {
        > .lista {
          justify-content: space-around;
        }
      }
    }

    @include media(">=tablet") {
      > .conteudo {
        > .lista {
          justify-content: flex-start;
          > .item {
            margin: 0 11px 30px 11px;
          }
        }
      }
    }


    @include media(">=hdscreen") {
      > .conteudo {
        > .lista {
          justify-content: flex-start;
          > .item {
            margin: 0 15px 30px 15px;
          }
        }
      }
    }
  }
</style>

<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Bloco from 'COMPONENTS/Bloco'
  import Titulo from 'COMPONENTS/ElementTitle'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Paginacao from 'COMPONENTS/Paginacao'
  import GaleriaAlbum from 'COMPONENTS/GaleriaAlbum'
  import GaleriaService from '../../js/api/GaleriaService'
  import utils from '../../js/utils'

  import * as config from '../../js/config'

  export default {
    components: {
      BackAndShare,
      Bloco,
      GaleriaAlbum,
      Titulo,
      Mensagem,
      Paginacao
    },
    data () {
      return {
        loading: true,
        album: {
          titulo: '',
          descricao: '',
          data: '',
          imagens: []
        },
        slug: '',
        naoTemFotos: false,
        imagemPrincipal: ''
      }
    },
    head: {
      title: function () {
        return {
          inner: config.SITE_TITLE + ' - ' + this.album.titulo
        }
      },
      meta: function () {
        return [
          { name: 'description', content: config.SITE_DESC + ' - ' + this.album.descricao, id: 'description' },
          { p: 'og:title', c: config.SITE_TITLE + ' - ' + this.album.titulo },
          { p: 'og:image', c: this.imagemPrincipal.url },
          { p: 'og:description', c: this.album.descricao }
        ]
      }
    },
    methods: {
      loadGaleria (slug) {
        GaleriaService.getFotos(slug)
        .then(galeriaDados => {
          this.album.titulo = galeriaDados.title.rendered
          this.album.descricao = galeriaDados.acf.descricao
          this.album.data = utils.dataWPFormatada(galeriaDados.date)
          let fotos = []
          galeriaDados.acf.fotos.forEach(function (foto) {
            fotos.push({
              id: foto.id,
              url: (foto.acf.link !== '') ? foto.acf.link : foto.acf.anexo,
              title: foto.acf.legenda_foto
            })
          })
          this.album.imagens = fotos
          this.imagemPrincipal = this.album.imagens[0]
          if (this.album.imagens.length === 0) {
            this.naoTemFotos = true
          }
        })
        .finally(() => {
          this.$emit('updateHead')
        })
      }
    },
    mounted () {
      this.slug = this.$route.params.slug || ''
      this.loadGaleria(this.slug)
    }
  }
</script>



// WEBPACK FOOTER //
// Album.vue?925ffc6e